import { encodePeriodValue, GlobalPeriodSelect } from '@components'

import { ReactElement, useCallback } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { PeriodValue } from '../../../../../../../../types/periodValue'
import { useImportedInvoicesListFilters } from '../../../../context/importedInvoicesListFilters'
import * as Styled from './styles'

export const ImportedInvoicesPeriodSelector = (): ReactElement => {
  const { organization } = useUserOrganization()
  const [{ period: queryParamPeriod }, setFilters] = useImportedInvoicesListFilters()
  const organizationId = organization?.id

  const handlePeriodChange = useCallback(
    (periodValue: PeriodValue) => {
      if (!organizationId) {
        return
      }

      setFilters({ page: 1, period: encodePeriodValue(periodValue, organizationId) })
    },
    [organizationId, setFilters],
  )

  return (
    <Styled.ImportedInvoicesPeriodSelector>
      <GlobalPeriodSelect encodedPeriod={queryParamPeriod} onChange={handlePeriodChange} placement="bottom-end" />
    </Styled.ImportedInvoicesPeriodSelector>
  )
}
